export default function getConfig() {

  let defaultImageFormats = {
    campaign: { width: 620, height: 620 },
    merchant: { width: 400, height: 400 }
  };

  if (window.env) {
    let availableLocales;
    try {
      availableLocales = JSON.parse(window.env.availableLocales);
    } catch (e) {
      availableLocales = ["Cannot parse availableLocales" + e];
    }

    let imageFormats;
    try {
      imageFormats = JSON.parse(window.env.imageFormats);
    }
    catch(e) {
      imageFormats = defaultImageFormats;
      imageFormats["err"] = e;
    }

    return {
      appName: window.env.appName,
      appUrl: window.env.appUrl,
      merchantApiUrl: window.env.merchantApiUrl,
      oauthApiUrl: window.env.oauthApiUrl,
      oauthClientId: window.env.oauthClientId,
      oauthRealm: window.env.oauthRealm,
      oauthPostback: window.env.oauthPostback,
      googleGeoApiKey: window.env.googleGeoApiKey,
      currency: window.env.currency,
      locale: window.env.locale,
      loginHint: window.env.loginHint,
      availableLocales: availableLocales,
      imageFormats: imageFormats,
    };
  }
  return {
    appName: "PLEASE CONFIGURE appName IN public/env.js",
    appUrl: "PLEASE CONFIGURE appUrl IN public/env.js",
    merchantApiUrl: "PLEASE CONFIGURE merchantApiUrl IN public/env.js",
    oauthApiUrl: "PLEASE CONFIGURE oauthApiUrl IN public/env.js",
    oauthClientId: "PLEASE CONFIGURE oauthClientId IN public/env.js",
    oauthRealm: "PLEASE CONFIGURE oauthRealm IN public/env.js",
    oauthPostback: "PLEASE CONFIGURE oauthPostback IN public/env.js",
    googleGeoApiKey: "PLEASE CONFIGURE googleGeoApiKey IN public/env.js",
    currency: "PLEASE CONFIGURE currency IN public/env.js",
    locale: "PLEASE CONFIGURE locale IN public/env.js",
    loginHint: "PLEASE CONFIGURE loginHint IN public/env.js",
    availableLocales:
      '{ "todo":"PLEASE CONFIGURE availableLocales IN public/env.js"}',
    imageFormats: defaultImageFormats,
  };
}
